import { setBreadcrumbs } from 'presentations/views/helpers/breadcrumbs';
import { useContext } from 'react';
import { ServicePortalContext } from 'presentations/reducers/ServicePortal';

export interface Props {
  breadcrumbs: { title: string; link: string }[];
}

export const useCustomerStoryListPage = (props: Props) => {
  const { state: serviceState } = useContext(ServicePortalContext);
  const viewer = serviceState.viewer;

  const routes = setBreadcrumbs(props.breadcrumbs);

  return {
    state: {
      viewer,
      routes,
    },
    actions: {},
  };
};
